<template>
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M5.66675 1.375C4.56218 1.375 3.66675 2.27043 3.66675 3.375L3.66675 18.625C3.66675 19.7296 4.56218 20.625 5.66675 20.625H16.3334C17.438 20.625 18.3334 19.7296 18.3334 18.625V7.28921C18.3334 7.024 18.2281 6.76964 18.0405 6.58211L13.1263 1.66789C12.9388 1.48036 12.6844 1.375 12.4192 1.375L5.66675 1.375ZM17.4167 7.79167L11.9167 2.29167V6.79167C11.9167 7.34395 12.3645 7.79167 12.9167 7.79167H17.4167Z" fill="currentColor"/>
	</svg>
</template>

<script>
  export default {};
</script>
